import {Loc} from 'landing.loc';

export const Fontawesome6_brands = {
	id: 'fontawesome6_brands',
	name: 'Fontawesome BRANDS',
	active: true,
	categories: [
		{
			id: 'brands',
			name: Loc.getMessage('LANDING_ICONS_SECTION_BRANDS'),
			items: [
				{
					className: 'fab fa-42-group',
					options: [
						'fab fa-42-group',
					],
					defaultOption: 'fab fa-42-group',
					keywords: '42 group',
				},
				{
					className: 'fab fa-500px',
					options: [
						'fab fa-500px',
					],
					defaultOption: 'fab fa-500px',
					keywords: '500px',
				},
				{
					className: 'fab fa-accessible-icon',
					options: [
						'fab fa-accessible-icon',
					],
					defaultOption: 'fab fa-accessible-icon',
					keywords: 'accessibility handicap person wheelchair wheelchair alt accessible icon',
				},
				{
					className: 'fab fa-accusoft',
					options: [
						'fab fa-accusoft',
					],
					defaultOption: 'fab fa-accusoft',
					keywords: 'accusoft',
				},
				{
					className: 'fab fa-acquisitions-incorporated',
					options: [
						'fab fa-acquisitions-incorporated',
					],
					defaultOption: 'fab fa-acquisitions-incorporated',
					keywords: 'dungeons & dragons d&d dnd fantasy game gaming tabletop acquisitions incorporated',
				},
				{
					className: 'fab fa-adn',
					options: [
						'fab fa-adn',
					],
					defaultOption: 'fab fa-adn',
					keywords: 'adn',
				},
				{
					className: 'fab fa-adversal',
					options: [
						'fab fa-adversal',
					],
					defaultOption: 'fab fa-adversal',
					keywords: 'adversal',
				},
				{
					className: 'fab fa-affiliatetheme',
					options: [
						'fab fa-affiliatetheme',
					],
					defaultOption: 'fab fa-affiliatetheme',
					keywords: 'affiliatetheme',
				},
				{
					className: 'fab fa-airbnb',
					options: [
						'fab fa-airbnb',
					],
					defaultOption: 'fab fa-airbnb',
					keywords: 'airbnb',
				},
				{
					className: 'fab fa-algolia',
					options: [
						'fab fa-algolia',
					],
					defaultOption: 'fab fa-algolia',
					keywords: 'algolia',
				},
				{
					className: 'fab fa-alipay',
					options: [
						'fab fa-alipay',
					],
					defaultOption: 'fab fa-alipay',
					keywords: 'alipay',
				},
				{
					className: 'fab fa-amazon',
					options: [
						'fab fa-amazon',
					],
					defaultOption: 'fab fa-amazon',
					keywords: 'amazon',
				},
				{
					className: 'fab fa-amazon-pay',
					options: [
						'fab fa-amazon-pay',
					],
					defaultOption: 'fab fa-amazon-pay',
					keywords: 'amazon pay',
				},
				{
					className: 'fab fa-amilia',
					options: [
						'fab fa-amilia',
					],
					defaultOption: 'fab fa-amilia',
					keywords: 'amilia',
				},
				{
					className: 'fab fa-android',
					options: [
						'fab fa-android',
					],
					defaultOption: 'fab fa-android',
					keywords: 'robot android',
				},
				{
					className: 'fab fa-angellist',
					options: [
						'fab fa-angellist',
					],
					defaultOption: 'fab fa-angellist',
					keywords: 'angellist',
				},
				{
					className: 'fab fa-angrycreative',
					options: [
						'fab fa-angrycreative',
					],
					defaultOption: 'fab fa-angrycreative',
					keywords: 'angrycreative',
				},
				{
					className: 'fab fa-angular',
					options: [
						'fab fa-angular',
					],
					defaultOption: 'fab fa-angular',
					keywords: 'angular',
				},
				{
					className: 'fab fa-app-store',
					options: [
						'fab fa-app-store',
					],
					defaultOption: 'fab fa-app-store',
					keywords: 'app store',
				},
				{
					className: 'fab fa-app-store-ios',
					options: [
						'fab fa-app-store-ios',
					],
					defaultOption: 'fab fa-app-store-ios',
					keywords: 'app store ios',
				},
				{
					className: 'fab fa-apper',
					options: [
						'fab fa-apper',
					],
					defaultOption: 'fab fa-apper',
					keywords: 'apper',
				},
				{
					className: 'fab fa-apple',
					options: [
						'fab fa-apple',
					],
					defaultOption: 'fab fa-apple',
					keywords: 'fruit ios mac operating system os osx apple',
				},
				{
					className: 'fab fa-apple-pay',
					options: [
						'fab fa-apple-pay',
					],
					defaultOption: 'fab fa-apple-pay',
					keywords: 'apple pay',
				},
				{
					className: 'fab fa-artstation',
					options: [
						'fab fa-artstation',
					],
					defaultOption: 'fab fa-artstation',
					keywords: 'artstation',
				},
				{
					className: 'fab fa-asymmetrik',
					options: [
						'fab fa-asymmetrik',
					],
					defaultOption: 'fab fa-asymmetrik',
					keywords: 'asymmetrik',
				},
				{
					className: 'fab fa-atlassian',
					options: [
						'fab fa-atlassian',
					],
					defaultOption: 'fab fa-atlassian',
					keywords: 'atlassian',
				},
				{
					className: 'fab fa-audible',
					options: [
						'fab fa-audible',
					],
					defaultOption: 'fab fa-audible',
					keywords: 'audible',
				},
				{
					className: 'fab fa-autoprefixer',
					options: [
						'fab fa-autoprefixer',
					],
					defaultOption: 'fab fa-autoprefixer',
					keywords: 'autoprefixer',
				},
				{
					className: 'fab fa-avianex',
					options: [
						'fab fa-avianex',
					],
					defaultOption: 'fab fa-avianex',
					keywords: 'avianex',
				},
				{
					className: 'fab fa-aviato',
					options: [
						'fab fa-aviato',
					],
					defaultOption: 'fab fa-aviato',
					keywords: 'aviato',
				},
				{
					className: 'fab fa-aws',
					options: [
						'fab fa-aws',
					],
					defaultOption: 'fab fa-aws',
					keywords: 'aws',
				},
				{
					className: 'fab fa-bandcamp',
					options: [
						'fab fa-bandcamp',
					],
					defaultOption: 'fab fa-bandcamp',
					keywords: 'bandcamp',
				},
				{
					className: 'fab fa-battle-net',
					options: [
						'fab fa-battle-net',
					],
					defaultOption: 'fab fa-battle-net',
					keywords: 'battle net',
				},
				{
					className: 'fab fa-behance',
					options: [
						'fab fa-behance',
					],
					defaultOption: 'fab fa-behance',
					keywords: 'behance',
				},
				{
					className: 'fab fa-behance-square',
					options: [
						'fab fa-behance-square',
					],
					defaultOption: 'fab fa-behance-square',
					keywords: 'behance square',
				},
				{
					className: 'fab fa-bilibili',
					options: [
						'fab fa-bilibili',
					],
					defaultOption: 'fab fa-bilibili',
					keywords: 'bilibili',
				},
				{
					className: 'fab fa-bimobject',
					options: [
						'fab fa-bimobject',
					],
					defaultOption: 'fab fa-bimobject',
					keywords: 'bimobject',
				},
				{
					className: 'fab fa-bitbucket',
					options: [
						'fab fa-bitbucket',
					],
					defaultOption: 'fab fa-bitbucket',
					keywords: 'atlassian bitbucket square git bitbucket',
				},
				{
					className: 'fab fa-bitcoin',
					options: [
						'fab fa-bitcoin',
					],
					defaultOption: 'fab fa-bitcoin',
					keywords: 'bitcoin',
				},
				{
					className: 'fab fa-bity',
					options: [
						'fab fa-bity',
					],
					defaultOption: 'fab fa-bity',
					keywords: 'bity',
				},
				{
					className: 'fab fa-black-tie',
					options: [
						'fab fa-black-tie',
					],
					defaultOption: 'fab fa-black-tie',
					keywords: 'black tie',
				},
				{
					className: 'fab fa-blackberry',
					options: [
						'fab fa-blackberry',
					],
					defaultOption: 'fab fa-blackberry',
					keywords: 'blackberry',
				},
				{
					className: 'fab fa-blogger',
					options: [
						'fab fa-blogger',
					],
					defaultOption: 'fab fa-blogger',
					keywords: 'blogger',
				},
				{
					className: 'fab fa-blogger-b',
					options: [
						'fab fa-blogger-b',
					],
					defaultOption: 'fab fa-blogger-b',
					keywords: 'blogger b',
				},
				{
					className: 'fab fa-bluetooth',
					options: [
						'fab fa-bluetooth',
					],
					defaultOption: 'fab fa-bluetooth',
					keywords: 'signal bluetooth',
				},
				{
					className: 'fab fa-bluetooth-b',
					options: [
						'fab fa-bluetooth-b',
					],
					defaultOption: 'fab fa-bluetooth-b',
					keywords: 'bluetooth b',
				},
				{
					className: 'fab fa-bootstrap',
					options: [
						'fab fa-bootstrap',
					],
					defaultOption: 'fab fa-bootstrap',
					keywords: 'bootstrap',
				},
				{
					className: 'fab fa-bots',
					options: [
						'fab fa-bots',
					],
					defaultOption: 'fab fa-bots',
					keywords: 'bots',
				},
				{
					className: 'fab fa-btc',
					options: [
						'fab fa-btc',
					],
					defaultOption: 'fab fa-btc',
					keywords: 'btc',
				},
				{
					className: 'fab fa-buffer',
					options: [
						'fab fa-buffer',
					],
					defaultOption: 'fab fa-buffer',
					keywords: 'buffer',
				},
				{
					className: 'fab fa-buromobelexperte',
					options: [
						'fab fa-buromobelexperte',
					],
					defaultOption: 'fab fa-buromobelexperte',
					keywords: 'buromobelexperte',
				},
				{
					className: 'fab fa-buy-n-large',
					options: [
						'fab fa-buy-n-large',
					],
					defaultOption: 'fab fa-buy-n-large',
					keywords: 'buy n large',
				},
				{
					className: 'fab fa-buysellads',
					options: [
						'fab fa-buysellads',
					],
					defaultOption: 'fab fa-buysellads',
					keywords: 'buysellads',
				},
				{
					className: 'fab fa-canadian-maple-leaf',
					options: [
						'fab fa-canadian-maple-leaf',
					],
					defaultOption: 'fab fa-canadian-maple-leaf',
					keywords: 'canada flag flora nature plant canadian maple leaf',
				},
				{
					className: 'fab fa-cc-amazon-pay',
					options: [
						'fab fa-cc-amazon-pay',
					],
					defaultOption: 'fab fa-cc-amazon-pay',
					keywords: 'cc amazon pay',
				},
				{
					className: 'fab fa-cc-amex',
					options: [
						'fab fa-cc-amex',
					],
					defaultOption: 'fab fa-cc-amex',
					keywords: 'amex cc amex',
				},
				{
					className: 'fab fa-cc-apple-pay',
					options: [
						'fab fa-cc-apple-pay',
					],
					defaultOption: 'fab fa-cc-apple-pay',
					keywords: 'cc apple pay',
				},
				{
					className: 'fab fa-cc-diners-club',
					options: [
						'fab fa-cc-diners-club',
					],
					defaultOption: 'fab fa-cc-diners-club',
					keywords: 'cc diners club',
				},
				{
					className: 'fab fa-cc-discover',
					options: [
						'fab fa-cc-discover',
					],
					defaultOption: 'fab fa-cc-discover',
					keywords: 'cc discover',
				},
				{
					className: 'fab fa-cc-jcb',
					options: [
						'fab fa-cc-jcb',
					],
					defaultOption: 'fab fa-cc-jcb',
					keywords: 'cc jcb',
				},
				{
					className: 'fab fa-cc-mastercard',
					options: [
						'fab fa-cc-mastercard',
					],
					defaultOption: 'fab fa-cc-mastercard',
					keywords: 'cc mastercard',
				},
				{
					className: 'fab fa-cc-paypal',
					options: [
						'fab fa-cc-paypal',
					],
					defaultOption: 'fab fa-cc-paypal',
					keywords: 'cc paypal',
				},
				{
					className: 'fab fa-cc-stripe',
					options: [
						'fab fa-cc-stripe',
					],
					defaultOption: 'fab fa-cc-stripe',
					keywords: 'cc stripe',
				},
				{
					className: 'fab fa-cc-visa',
					options: [
						'fab fa-cc-visa',
					],
					defaultOption: 'fab fa-cc-visa',
					keywords: 'cc visa',
				},
				{
					className: 'fab fa-centercode',
					options: [
						'fab fa-centercode',
					],
					defaultOption: 'fab fa-centercode',
					keywords: 'centercode',
				},
				{
					className: 'fab fa-centos',
					options: [
						'fab fa-centos',
					],
					defaultOption: 'fab fa-centos',
					keywords: 'linux operating system os centos',
				},
				{
					className: 'fab fa-chrome',
					options: [
						'fab fa-chrome',
					],
					defaultOption: 'fab fa-chrome',
					keywords: 'browser chrome',
				},
				{
					className: 'fab fa-chromecast',
					options: [
						'fab fa-chromecast',
					],
					defaultOption: 'fab fa-chromecast',
					keywords: 'chromecast',
				},
				{
					className: 'fab fa-cloudflare',
					options: [
						'fab fa-cloudflare',
					],
					defaultOption: 'fab fa-cloudflare',
					keywords: 'cloudflare',
				},
				{
					className: 'fab fa-cloudscale',
					options: [
						'fab fa-cloudscale',
					],
					defaultOption: 'fab fa-cloudscale',
					keywords: 'cloudscale',
				},
				{
					className: 'fab fa-cloudsmith',
					options: [
						'fab fa-cloudsmith',
					],
					defaultOption: 'fab fa-cloudsmith',
					keywords: 'cloudsmith',
				},
				{
					className: 'fab fa-cloudversify',
					options: [
						'fab fa-cloudversify',
					],
					defaultOption: 'fab fa-cloudversify',
					keywords: 'cloudversify',
				},
				{
					className: 'fab fa-cmplid',
					options: [
						'fab fa-cmplid',
					],
					defaultOption: 'fab fa-cmplid',
					keywords: 'cmplid',
				},
				{
					className: 'fab fa-codepen',
					options: [
						'fab fa-codepen',
					],
					defaultOption: 'fab fa-codepen',
					keywords: 'codepen',
				},
				{
					className: 'fab fa-codiepie',
					options: [
						'fab fa-codiepie',
					],
					defaultOption: 'fab fa-codiepie',
					keywords: 'codiepie',
				},
				{
					className: 'fab fa-confluence',
					options: [
						'fab fa-confluence',
					],
					defaultOption: 'fab fa-confluence',
					keywords: 'atlassian confluence',
				},
				{
					className: 'fab fa-connectdevelop',
					options: [
						'fab fa-connectdevelop',
					],
					defaultOption: 'fab fa-connectdevelop',
					keywords: 'connectdevelop',
				},
				{
					className: 'fab fa-contao',
					options: [
						'fab fa-contao',
					],
					defaultOption: 'fab fa-contao',
					keywords: 'contao',
				},
				{
					className: 'fab fa-cotton-bureau',
					options: [
						'fab fa-cotton-bureau',
					],
					defaultOption: 'fab fa-cotton-bureau',
					keywords: 'clothing t shirts tshirts cotton bureau',
				},
				{
					className: 'fab fa-cpanel',
					options: [
						'fab fa-cpanel',
					],
					defaultOption: 'fab fa-cpanel',
					keywords: 'cpanel',
				},
				{
					className: 'fab fa-creative-commons',
					options: [
						'fab fa-creative-commons',
					],
					defaultOption: 'fab fa-creative-commons',
					keywords: 'creative commons',
				},
				{
					className: 'fab fa-creative-commons-by',
					options: [
						'fab fa-creative-commons-by',
					],
					defaultOption: 'fab fa-creative-commons-by',
					keywords: 'creative commons by',
				},
				{
					className: 'fab fa-creative-commons-nc',
					options: [
						'fab fa-creative-commons-nc',
					],
					defaultOption: 'fab fa-creative-commons-nc',
					keywords: 'creative commons nc',
				},
				{
					className: 'fab fa-creative-commons-nc-eu',
					options: [
						'fab fa-creative-commons-nc-eu',
					],
					defaultOption: 'fab fa-creative-commons-nc-eu',
					keywords: 'creative commons nc eu',
				},
				{
					className: 'fab fa-creative-commons-nc-jp',
					options: [
						'fab fa-creative-commons-nc-jp',
					],
					defaultOption: 'fab fa-creative-commons-nc-jp',
					keywords: 'creative commons nc jp',
				},
				{
					className: 'fab fa-creative-commons-nd',
					options: [
						'fab fa-creative-commons-nd',
					],
					defaultOption: 'fab fa-creative-commons-nd',
					keywords: 'creative commons nd',
				},
				{
					className: 'fab fa-creative-commons-pd',
					options: [
						'fab fa-creative-commons-pd',
					],
					defaultOption: 'fab fa-creative-commons-pd',
					keywords: 'creative commons pd',
				},
				{
					className: 'fab fa-creative-commons-pd-alt',
					options: [
						'fab fa-creative-commons-pd-alt',
					],
					defaultOption: 'fab fa-creative-commons-pd-alt',
					keywords: 'creative commons pd alt',
				},
				{
					className: 'fab fa-creative-commons-remix',
					options: [
						'fab fa-creative-commons-remix',
					],
					defaultOption: 'fab fa-creative-commons-remix',
					keywords: 'creative commons remix',
				},
				{
					className: 'fab fa-creative-commons-sa',
					options: [
						'fab fa-creative-commons-sa',
					],
					defaultOption: 'fab fa-creative-commons-sa',
					keywords: 'creative commons sa',
				},
				{
					className: 'fab fa-creative-commons-sampling',
					options: [
						'fab fa-creative-commons-sampling',
					],
					defaultOption: 'fab fa-creative-commons-sampling',
					keywords: 'creative commons sampling',
				},
				{
					className: 'fab fa-creative-commons-sampling-plus',
					options: [
						'fab fa-creative-commons-sampling-plus',
					],
					defaultOption: 'fab fa-creative-commons-sampling-plus',
					keywords: 'creative commons sampling plus',
				},
				{
					className: 'fab fa-creative-commons-share',
					options: [
						'fab fa-creative-commons-share',
					],
					defaultOption: 'fab fa-creative-commons-share',
					keywords: 'creative commons share',
				},
				{
					className: 'fab fa-creative-commons-zero',
					options: [
						'fab fa-creative-commons-zero',
					],
					defaultOption: 'fab fa-creative-commons-zero',
					keywords: 'creative commons zero',
				},
				{
					className: 'fab fa-critical-role',
					options: [
						'fab fa-critical-role',
					],
					defaultOption: 'fab fa-critical-role',
					keywords: 'dungeons & dragons d&d dnd fantasy game gaming tabletop critical role',
				},
				{
					className: 'fab fa-css3',
					options: [
						'fab fa-css3',
					],
					defaultOption: 'fab fa-css3',
					keywords: 'code css3',
				},
				{
					className: 'fab fa-css3-alt',
					options: [
						'fab fa-css3-alt',
					],
					defaultOption: 'fab fa-css3-alt',
					keywords: 'css3 alt',
				},
				{
					className: 'fab fa-cuttlefish',
					options: [
						'fab fa-cuttlefish',
					],
					defaultOption: 'fab fa-cuttlefish',
					keywords: 'cuttlefish',
				},
				{
					className: 'fab fa-d-and-d',
					options: [
						'fab fa-d-and-d',
					],
					defaultOption: 'fab fa-d-and-d',
					keywords: 'd and d',
				},
				{
					className: 'fab fa-d-and-d-beyond',
					options: [
						'fab fa-d-and-d-beyond',
					],
					defaultOption: 'fab fa-d-and-d-beyond',
					keywords: 'dungeons & dragons d&d dnd fantasy gaming tabletop d and d beyond',
				},
				{
					className: 'fab fa-dailymotion',
					options: [
						'fab fa-dailymotion',
					],
					defaultOption: 'fab fa-dailymotion',
					keywords: 'dailymotion',
				},
				{
					className: 'fab fa-dashcube',
					options: [
						'fab fa-dashcube',
					],
					defaultOption: 'fab fa-dashcube',
					keywords: 'dashcube',
				},
				{
					className: 'fab fa-deezer',
					options: [
						'fab fa-deezer',
					],
					defaultOption: 'fab fa-deezer',
					keywords: 'deezer',
				},
				{
					className: 'fab fa-delicious',
					options: [
						'fab fa-delicious',
					],
					defaultOption: 'fab fa-delicious',
					keywords: 'delicious',
				},
				{
					className: 'fab fa-deploydog',
					options: [
						'fab fa-deploydog',
					],
					defaultOption: 'fab fa-deploydog',
					keywords: 'deploydog',
				},
				{
					className: 'fab fa-deskpro',
					options: [
						'fab fa-deskpro',
					],
					defaultOption: 'fab fa-deskpro',
					keywords: 'deskpro',
				},
				{
					className: 'fab fa-dev',
					options: [
						'fab fa-dev',
					],
					defaultOption: 'fab fa-dev',
					keywords: 'dev',
				},
				{
					className: 'fab fa-deviantart',
					options: [
						'fab fa-deviantart',
					],
					defaultOption: 'fab fa-deviantart',
					keywords: 'deviantart',
				},
				{
					className: 'fab fa-dhl',
					options: [
						'fab fa-dhl',
					],
					defaultOption: 'fab fa-dhl',
					keywords: 'dalsey hillblom and lynn german package shipping dhl',
				},
				{
					className: 'fab fa-diaspora',
					options: [
						'fab fa-diaspora',
					],
					defaultOption: 'fab fa-diaspora',
					keywords: 'diaspora',
				},
				{
					className: 'fab fa-digg',
					options: [
						'fab fa-digg',
					],
					defaultOption: 'fab fa-digg',
					keywords: 'digg',
				},
				{
					className: 'fab fa-digital-ocean',
					options: [
						'fab fa-digital-ocean',
					],
					defaultOption: 'fab fa-digital-ocean',
					keywords: 'digital ocean',
				},
				{
					className: 'fab fa-discord',
					options: [
						'fab fa-discord',
					],
					defaultOption: 'fab fa-discord',
					keywords: 'discord',
				},
				{
					className: 'fab fa-discourse',
					options: [
						'fab fa-discourse',
					],
					defaultOption: 'fab fa-discourse',
					keywords: 'discourse',
				},
				{
					className: 'fab fa-dochub',
					options: [
						'fab fa-dochub',
					],
					defaultOption: 'fab fa-dochub',
					keywords: 'dochub',
				},
				{
					className: 'fab fa-docker',
					options: [
						'fab fa-docker',
					],
					defaultOption: 'fab fa-docker',
					keywords: 'docker',
				},
				{
					className: 'fab fa-draft2digital',
					options: [
						'fab fa-draft2digital',
					],
					defaultOption: 'fab fa-draft2digital',
					keywords: 'draft2digital',
				},
				{
					className: 'fab fa-dribbble',
					options: [
						'fab fa-dribbble',
					],
					defaultOption: 'fab fa-dribbble',
					keywords: 'dribbble',
				},
				{
					className: 'fab fa-dribbble-square',
					options: [
						'fab fa-dribbble-square',
					],
					defaultOption: 'fab fa-dribbble-square',
					keywords: 'dribbble square',
				},
				{
					className: 'fab fa-dropbox',
					options: [
						'fab fa-dropbox',
					],
					defaultOption: 'fab fa-dropbox',
					keywords: 'dropbox',
				},
				{
					className: 'fab fa-drupal',
					options: [
						'fab fa-drupal',
					],
					defaultOption: 'fab fa-drupal',
					keywords: 'drupal',
				},
				{
					className: 'fab fa-dyalog',
					options: [
						'fab fa-dyalog',
					],
					defaultOption: 'fab fa-dyalog',
					keywords: 'dyalog',
				},
				{
					className: 'fab fa-earlybirds',
					options: [
						'fab fa-earlybirds',
					],
					defaultOption: 'fab fa-earlybirds',
					keywords: 'earlybirds',
				},
				{
					className: 'fab fa-ebay',
					options: [
						'fab fa-ebay',
					],
					defaultOption: 'fab fa-ebay',
					keywords: 'ebay',
				},
				{
					className: 'fab fa-edge',
					options: [
						'fab fa-edge',
					],
					defaultOption: 'fab fa-edge',
					keywords: 'browser ie edge',
				},
				{
					className: 'fab fa-edge-legacy',
					options: [
						'fab fa-edge-legacy',
					],
					defaultOption: 'fab fa-edge-legacy',
					keywords: 'edge legacy',
				},
				{
					className: 'fab fa-elementor',
					options: [
						'fab fa-elementor',
					],
					defaultOption: 'fab fa-elementor',
					keywords: 'elementor',
				},
				{
					className: 'fab fa-ello',
					options: [
						'fab fa-ello',
					],
					defaultOption: 'fab fa-ello',
					keywords: 'ello',
				},
				{
					className: 'fab fa-ember',
					options: [
						'fab fa-ember',
					],
					defaultOption: 'fab fa-ember',
					keywords: 'ember',
				},
				{
					className: 'fab fa-empire',
					options: [
						'fab fa-empire',
					],
					defaultOption: 'fab fa-empire',
					keywords: 'empire',
				},
				{
					className: 'fab fa-envira',
					options: [
						'fab fa-envira',
					],
					defaultOption: 'fab fa-envira',
					keywords: 'leaf envira',
				},
				{
					className: 'fab fa-erlang',
					options: [
						'fab fa-erlang',
					],
					defaultOption: 'fab fa-erlang',
					keywords: 'erlang',
				},
				{
					className: 'fab fa-ethereum',
					options: [
						'fab fa-ethereum',
					],
					defaultOption: 'fab fa-ethereum',
					keywords: 'ethereum',
				},
				{
					className: 'fab fa-etsy',
					options: [
						'fab fa-etsy',
					],
					defaultOption: 'fab fa-etsy',
					keywords: 'etsy',
				},
				{
					className: 'fab fa-evernote',
					options: [
						'fab fa-evernote',
					],
					defaultOption: 'fab fa-evernote',
					keywords: 'evernote',
				},
				{
					className: 'fab fa-expeditedssl',
					options: [
						'fab fa-expeditedssl',
					],
					defaultOption: 'fab fa-expeditedssl',
					keywords: 'expeditedssl',
				},
				{
					className: 'fab fa-facebook',
					options: [
						'fab fa-facebook',
					],
					defaultOption: 'fab fa-facebook',
					keywords: 'facebook official social network facebook',
				},
				{
					className: 'fab fa-facebook-f',
					options: [
						'fab fa-facebook-f',
					],
					defaultOption: 'fab fa-facebook-f',
					keywords: 'facebook facebook f',
				},
				{
					className: 'fab fa-facebook-messenger',
					options: [
						'fab fa-facebook-messenger',
					],
					defaultOption: 'fab fa-facebook-messenger',
					keywords: 'facebook messenger',
				},
				{
					className: 'fab fa-facebook-square',
					options: [
						'fab fa-facebook-square',
					],
					defaultOption: 'fab fa-facebook-square',
					keywords: 'social network facebook square',
				},
				{
					className: 'fab fa-fantasy-flight-games',
					options: [
						'fab fa-fantasy-flight-games',
					],
					defaultOption: 'fab fa-fantasy-flight-games',
					keywords: 'dungeons & dragons d&d dnd fantasy game gaming tabletop fantasy flight games',
				},
				{
					className: 'fab fa-fedex',
					options: [
						'fab fa-fedex',
					],
					defaultOption: 'fab fa-fedex',
					keywords: 'federal express package shipping fedex',
				},
				{
					className: 'fab fa-fedora',
					options: [
						'fab fa-fedora',
					],
					defaultOption: 'fab fa-fedora',
					keywords: 'linux operating system os fedora',
				},
				{
					className: 'fab fa-figma',
					options: [
						'fab fa-figma',
					],
					defaultOption: 'fab fa-figma',
					keywords: 'app design interface figma',
				},
				{
					className: 'fab fa-firefox',
					options: [
						'fab fa-firefox',
					],
					defaultOption: 'fab fa-firefox',
					keywords: 'browser firefox',
				},
				{
					className: 'fab fa-firefox-browser',
					options: [
						'fab fa-firefox-browser',
					],
					defaultOption: 'fab fa-firefox-browser',
					keywords: 'browser firefox browser',
				},
				{
					className: 'fab fa-first-order',
					options: [
						'fab fa-first-order',
					],
					defaultOption: 'fab fa-first-order',
					keywords: 'first order',
				},
				{
					className: 'fab fa-first-order-alt',
					options: [
						'fab fa-first-order-alt',
					],
					defaultOption: 'fab fa-first-order-alt',
					keywords: 'first order alt',
				},
				{
					className: 'fab fa-firstdraft',
					options: [
						'fab fa-firstdraft',
					],
					defaultOption: 'fab fa-firstdraft',
					keywords: 'firstdraft',
				},
				{
					className: 'fab fa-flickr',
					options: [
						'fab fa-flickr',
					],
					defaultOption: 'fab fa-flickr',
					keywords: 'flickr',
				},
				{
					className: 'fab fa-flipboard',
					options: [
						'fab fa-flipboard',
					],
					defaultOption: 'fab fa-flipboard',
					keywords: 'flipboard',
				},
				{
					className: 'fab fa-fly',
					options: [
						'fab fa-fly',
					],
					defaultOption: 'fab fa-fly',
					keywords: 'fly',
				},
				{
					className: 'fab fa-font-awesome',
					options: [
						'fab fa-font-awesome',
					],
					defaultOption: 'fab fa-font-awesome',
					keywords: 'font awesome',
				},
				{
					className: 'fab fa-fonticons',
					options: [
						'fab fa-fonticons',
					],
					defaultOption: 'fab fa-fonticons',
					keywords: 'fonticons',
				},
				{
					className: 'fab fa-fonticons-fi',
					options: [
						'fab fa-fonticons-fi',
					],
					defaultOption: 'fab fa-fonticons-fi',
					keywords: 'fonticons fi',
				},
				{
					className: 'fab fa-fort-awesome',
					options: [
						'fab fa-fort-awesome',
					],
					defaultOption: 'fab fa-fort-awesome',
					keywords: 'castle fort awesome',
				},
				{
					className: 'fab fa-fort-awesome-alt',
					options: [
						'fab fa-fort-awesome-alt',
					],
					defaultOption: 'fab fa-fort-awesome-alt',
					keywords: 'castle fort awesome alt',
				},
				{
					className: 'fab fa-forumbee',
					options: [
						'fab fa-forumbee',
					],
					defaultOption: 'fab fa-forumbee',
					keywords: 'forumbee',
				},
				{
					className: 'fab fa-foursquare',
					options: [
						'fab fa-foursquare',
					],
					defaultOption: 'fab fa-foursquare',
					keywords: 'foursquare',
				},
				{
					className: 'fab fa-free-code-camp',
					options: [
						'fab fa-free-code-camp',
					],
					defaultOption: 'fab fa-free-code-camp',
					keywords: 'free code camp',
				},
				{
					className: 'fab fa-freebsd',
					options: [
						'fab fa-freebsd',
					],
					defaultOption: 'fab fa-freebsd',
					keywords: 'freebsd',
				},
				{
					className: 'fab fa-fulcrum',
					options: [
						'fab fa-fulcrum',
					],
					defaultOption: 'fab fa-fulcrum',
					keywords: 'fulcrum',
				},
				{
					className: 'fab fa-galactic-republic',
					options: [
						'fab fa-galactic-republic',
					],
					defaultOption: 'fab fa-galactic-republic',
					keywords: 'politics star wars galactic republic',
				},
				{
					className: 'fab fa-galactic-senate',
					options: [
						'fab fa-galactic-senate',
					],
					defaultOption: 'fab fa-galactic-senate',
					keywords: 'star wars galactic senate',
				},
				{
					className: 'fab fa-get-pocket',
					options: [
						'fab fa-get-pocket',
					],
					defaultOption: 'fab fa-get-pocket',
					keywords: 'get pocket',
				},
				{
					className: 'fab fa-gg',
					options: [
						'fab fa-gg',
					],
					defaultOption: 'fab fa-gg',
					keywords: 'gg',
				},
				{
					className: 'fab fa-gg-circle',
					options: [
						'fab fa-gg-circle',
					],
					defaultOption: 'fab fa-gg-circle',
					keywords: 'gg circle',
				},
				{
					className: 'fab fa-git',
					options: [
						'fab fa-git',
					],
					defaultOption: 'fab fa-git',
					keywords: 'git',
				},
				{
					className: 'fab fa-git-alt',
					options: [
						'fab fa-git-alt',
					],
					defaultOption: 'fab fa-git-alt',
					keywords: 'git alt',
				},
				{
					className: 'fab fa-git-square',
					options: [
						'fab fa-git-square',
					],
					defaultOption: 'fab fa-git-square',
					keywords: 'git square',
				},
				{
					className: 'fab fa-github',
					options: [
						'fab fa-github',
					],
					defaultOption: 'fab fa-github',
					keywords: 'octocat github',
				},
				{
					className: 'fab fa-github-alt',
					options: [
						'fab fa-github-alt',
					],
					defaultOption: 'fab fa-github-alt',
					keywords: 'octocat github alt',
				},
				{
					className: 'fab fa-github-square',
					options: [
						'fab fa-github-square',
					],
					defaultOption: 'fab fa-github-square',
					keywords: 'octocat github square',
				},
				{
					className: 'fab fa-gitkraken',
					options: [
						'fab fa-gitkraken',
					],
					defaultOption: 'fab fa-gitkraken',
					keywords: 'gitkraken',
				},
				{
					className: 'fab fa-gitlab',
					options: [
						'fab fa-gitlab',
					],
					defaultOption: 'fab fa-gitlab',
					keywords: 'axosoft gitlab',
				},
				{
					className: 'fab fa-gitter',
					options: [
						'fab fa-gitter',
					],
					defaultOption: 'fab fa-gitter',
					keywords: 'gitter',
				},
				{
					className: 'fab fa-glide',
					options: [
						'fab fa-glide',
					],
					defaultOption: 'fab fa-glide',
					keywords: 'glide',
				},
				{
					className: 'fab fa-glide-g',
					options: [
						'fab fa-glide-g',
					],
					defaultOption: 'fab fa-glide-g',
					keywords: 'glide g',
				},
				{
					className: 'fab fa-gofore',
					options: [
						'fab fa-gofore',
					],
					defaultOption: 'fab fa-gofore',
					keywords: 'gofore',
				},
				{
					className: 'fab fa-golang',
					options: [
						'fab fa-golang',
					],
					defaultOption: 'fab fa-golang',
					keywords: 'golang',
				},
				{
					className: 'fab fa-goodreads',
					options: [
						'fab fa-goodreads',
					],
					defaultOption: 'fab fa-goodreads',
					keywords: 'goodreads',
				},
				{
					className: 'fab fa-goodreads-g',
					options: [
						'fab fa-goodreads-g',
					],
					defaultOption: 'fab fa-goodreads-g',
					keywords: 'goodreads g',
				},
				{
					className: 'fab fa-google',
					options: [
						'fab fa-google',
					],
					defaultOption: 'fab fa-google',
					keywords: 'google',
				},
				{
					className: 'fab fa-google-drive',
					options: [
						'fab fa-google-drive',
					],
					defaultOption: 'fab fa-google-drive',
					keywords: 'google drive',
				},
				{
					className: 'fab fa-google-pay',
					options: [
						'fab fa-google-pay',
					],
					defaultOption: 'fab fa-google-pay',
					keywords: 'google pay',
				},
				{
					className: 'fab fa-google-play',
					options: [
						'fab fa-google-play',
					],
					defaultOption: 'fab fa-google-play',
					keywords: 'google play',
				},
				{
					className: 'fab fa-google-plus',
					options: [
						'fab fa-google-plus',
					],
					defaultOption: 'fab fa-google-plus',
					keywords: 'google plus circle google plus official google plus',
				},
				{
					className: 'fab fa-google-plus-g',
					options: [
						'fab fa-google-plus-g',
					],
					defaultOption: 'fab fa-google-plus-g',
					keywords: 'google plus social network google plus g',
				},
				{
					className: 'fab fa-google-plus-square',
					options: [
						'fab fa-google-plus-square',
					],
					defaultOption: 'fab fa-google-plus-square',
					keywords: 'social network google plus square',
				},
				{
					className: 'fab fa-google-wallet',
					options: [
						'fab fa-google-wallet',
					],
					defaultOption: 'fab fa-google-wallet',
					keywords: 'google wallet',
				},
				{
					className: 'fab fa-gratipay',
					options: [
						'fab fa-gratipay',
					],
					defaultOption: 'fab fa-gratipay',
					keywords: 'favorite heart like love gratipay',
				},
				{
					className: 'fab fa-grav',
					options: [
						'fab fa-grav',
					],
					defaultOption: 'fab fa-grav',
					keywords: 'grav',
				},
				{
					className: 'fab fa-gripfire',
					options: [
						'fab fa-gripfire',
					],
					defaultOption: 'fab fa-gripfire',
					keywords: 'gripfire',
				},
				{
					className: 'fab fa-grunt',
					options: [
						'fab fa-grunt',
					],
					defaultOption: 'fab fa-grunt',
					keywords: 'grunt',
				},
				{
					className: 'fab fa-guilded',
					options: [
						'fab fa-guilded',
					],
					defaultOption: 'fab fa-guilded',
					keywords: 'guilded',
				},
				{
					className: 'fab fa-gulp',
					options: [
						'fab fa-gulp',
					],
					defaultOption: 'fab fa-gulp',
					keywords: 'gulp',
				},
				{
					className: 'fab fa-hacker-news',
					options: [
						'fab fa-hacker-news',
					],
					defaultOption: 'fab fa-hacker-news',
					keywords: 'hacker news',
				},
				{
					className: 'fab fa-hacker-news-square',
					options: [
						'fab fa-hacker-news-square',
					],
					defaultOption: 'fab fa-hacker-news-square',
					keywords: 'hacker news square',
				},
				{
					className: 'fab fa-hackerrank',
					options: [
						'fab fa-hackerrank',
					],
					defaultOption: 'fab fa-hackerrank',
					keywords: 'hackerrank',
				},
				{
					className: 'fab fa-hips',
					options: [
						'fab fa-hips',
					],
					defaultOption: 'fab fa-hips',
					keywords: 'hips',
				},
				{
					className: 'fab fa-hire-a-helper',
					options: [
						'fab fa-hire-a-helper',
					],
					defaultOption: 'fab fa-hire-a-helper',
					keywords: 'hire a helper',
				},
				{
					className: 'fab fa-hive',
					options: [
						'fab fa-hive',
					],
					defaultOption: 'fab fa-hive',
					keywords: 'hive',
				},
				{
					className: 'fab fa-hooli',
					options: [
						'fab fa-hooli',
					],
					defaultOption: 'fab fa-hooli',
					keywords: 'hooli',
				},
				{
					className: 'fab fa-hornbill',
					options: [
						'fab fa-hornbill',
					],
					defaultOption: 'fab fa-hornbill',
					keywords: 'hornbill',
				},
				{
					className: 'fab fa-hotjar',
					options: [
						'fab fa-hotjar',
					],
					defaultOption: 'fab fa-hotjar',
					keywords: 'hotjar',
				},
				{
					className: 'fab fa-houzz',
					options: [
						'fab fa-houzz',
					],
					defaultOption: 'fab fa-houzz',
					keywords: 'houzz',
				},
				{
					className: 'fab fa-html5',
					options: [
						'fab fa-html5',
					],
					defaultOption: 'fab fa-html5',
					keywords: 'html5',
				},
				{
					className: 'fab fa-hubspot',
					options: [
						'fab fa-hubspot',
					],
					defaultOption: 'fab fa-hubspot',
					keywords: 'hubspot',
				},
				{
					className: 'fab fa-ideal',
					options: [
						'fab fa-ideal',
					],
					defaultOption: 'fab fa-ideal',
					keywords: 'ideal',
				},
				{
					className: 'fab fa-imdb',
					options: [
						'fab fa-imdb',
					],
					defaultOption: 'fab fa-imdb',
					keywords: 'imdb',
				},
				{
					className: 'fab fa-instagram',
					options: [
						'fab fa-instagram',
					],
					defaultOption: 'fab fa-instagram',
					keywords: 'instagram',
				},
				{
					className: 'fab fa-instagram-square',
					options: [
						'fab fa-instagram-square',
					],
					defaultOption: 'fab fa-instagram-square',
					keywords: 'instagram square',
				},
				{
					className: 'fab fa-instalod',
					options: [
						'fab fa-instalod',
					],
					defaultOption: 'fab fa-instalod',
					keywords: 'instalod',
				},
				{
					className: 'fab fa-intercom',
					options: [
						'fab fa-intercom',
					],
					defaultOption: 'fab fa-intercom',
					keywords: 'app customer messenger intercom',
				},
				{
					className: 'fab fa-internet-explorer',
					options: [
						'fab fa-internet-explorer',
					],
					defaultOption: 'fab fa-internet-explorer',
					keywords: 'browser ie internet explorer',
				},
				{
					className: 'fab fa-invision',
					options: [
						'fab fa-invision',
					],
					defaultOption: 'fab fa-invision',
					keywords: 'app design interface invision',
				},
				{
					className: 'fab fa-ioxhost',
					options: [
						'fab fa-ioxhost',
					],
					defaultOption: 'fab fa-ioxhost',
					keywords: 'ioxhost',
				},
				{
					className: 'fab fa-itch-io',
					options: [
						'fab fa-itch-io',
					],
					defaultOption: 'fab fa-itch-io',
					keywords: 'itch io',
				},
				{
					className: 'fab fa-itunes',
					options: [
						'fab fa-itunes',
					],
					defaultOption: 'fab fa-itunes',
					keywords: 'itunes',
				},
				{
					className: 'fab fa-itunes-note',
					options: [
						'fab fa-itunes-note',
					],
					defaultOption: 'fab fa-itunes-note',
					keywords: 'itunes note',
				},
				{
					className: 'fab fa-java',
					options: [
						'fab fa-java',
					],
					defaultOption: 'fab fa-java',
					keywords: 'java',
				},
				{
					className: 'fab fa-jedi-order',
					options: [
						'fab fa-jedi-order',
					],
					defaultOption: 'fab fa-jedi-order',
					keywords: 'star wars jedi order',
				},
				{
					className: 'fab fa-jenkins',
					options: [
						'fab fa-jenkins',
					],
					defaultOption: 'fab fa-jenkins',
					keywords: 'jenkins',
				},
				{
					className: 'fab fa-jira',
					options: [
						'fab fa-jira',
					],
					defaultOption: 'fab fa-jira',
					keywords: 'atlassian jira',
				},
				{
					className: 'fab fa-joget',
					options: [
						'fab fa-joget',
					],
					defaultOption: 'fab fa-joget',
					keywords: 'joget',
				},
				{
					className: 'fab fa-joomla',
					options: [
						'fab fa-joomla',
					],
					defaultOption: 'fab fa-joomla',
					keywords: 'joomla',
				},
				{
					className: 'fab fa-js',
					options: [
						'fab fa-js',
					],
					defaultOption: 'fab fa-js',
					keywords: 'js',
				},
				{
					className: 'fab fa-js-square',
					options: [
						'fab fa-js-square',
					],
					defaultOption: 'fab fa-js-square',
					keywords: 'js square',
				},
				{
					className: 'fab fa-jsfiddle',
					options: [
						'fab fa-jsfiddle',
					],
					defaultOption: 'fab fa-jsfiddle',
					keywords: 'jsfiddle',
				},
				{
					className: 'fab fa-kaggle',
					options: [
						'fab fa-kaggle',
					],
					defaultOption: 'fab fa-kaggle',
					keywords: 'kaggle',
				},
				{
					className: 'fab fa-keybase',
					options: [
						'fab fa-keybase',
					],
					defaultOption: 'fab fa-keybase',
					keywords: 'keybase',
				},
				{
					className: 'fab fa-keycdn',
					options: [
						'fab fa-keycdn',
					],
					defaultOption: 'fab fa-keycdn',
					keywords: 'keycdn',
				},
				{
					className: 'fab fa-kickstarter',
					options: [
						'fab fa-kickstarter',
					],
					defaultOption: 'fab fa-kickstarter',
					keywords: 'kickstarter',
				},
				{
					className: 'fab fa-kickstarter-k',
					options: [
						'fab fa-kickstarter-k',
					],
					defaultOption: 'fab fa-kickstarter-k',
					keywords: 'kickstarter k',
				},
				{
					className: 'fab fa-korvue',
					options: [
						'fab fa-korvue',
					],
					defaultOption: 'fab fa-korvue',
					keywords: 'korvue',
				},
				{
					className: 'fab fa-laravel',
					options: [
						'fab fa-laravel',
					],
					defaultOption: 'fab fa-laravel',
					keywords: 'laravel',
				},
				{
					className: 'fab fa-lastfm',
					options: [
						'fab fa-lastfm',
					],
					defaultOption: 'fab fa-lastfm',
					keywords: 'lastfm',
				},
				{
					className: 'fab fa-lastfm-square',
					options: [
						'fab fa-lastfm-square',
					],
					defaultOption: 'fab fa-lastfm-square',
					keywords: 'lastfm square',
				},
				{
					className: 'fab fa-leanpub',
					options: [
						'fab fa-leanpub',
					],
					defaultOption: 'fab fa-leanpub',
					keywords: 'leanpub',
				},
				{
					className: 'fab fa-less',
					options: [
						'fab fa-less',
					],
					defaultOption: 'fab fa-less',
					keywords: 'less',
				},
				{
					className: 'fab fa-line',
					options: [
						'fab fa-line',
					],
					defaultOption: 'fab fa-line',
					keywords: 'line',
				},
				{
					className: 'fab fa-linkedin',
					options: [
						'fab fa-linkedin',
					],
					defaultOption: 'fab fa-linkedin',
					keywords: 'linkedin square linkedin',
				},
				{
					className: 'fab fa-linkedin-in',
					options: [
						'fab fa-linkedin-in',
					],
					defaultOption: 'fab fa-linkedin-in',
					keywords: 'linkedin linkedin in',
				},
				{
					className: 'fab fa-linode',
					options: [
						'fab fa-linode',
					],
					defaultOption: 'fab fa-linode',
					keywords: 'linode',
				},
				{
					className: 'fab fa-linux',
					options: [
						'fab fa-linux',
					],
					defaultOption: 'fab fa-linux',
					keywords: 'tux linux',
				},
				{
					className: 'fab fa-lyft',
					options: [
						'fab fa-lyft',
					],
					defaultOption: 'fab fa-lyft',
					keywords: 'lyft',
				},
				{
					className: 'fab fa-magento',
					options: [
						'fab fa-magento',
					],
					defaultOption: 'fab fa-magento',
					keywords: 'magento',
				},
				{
					className: 'fab fa-mailchimp',
					options: [
						'fab fa-mailchimp',
					],
					defaultOption: 'fab fa-mailchimp',
					keywords: 'mailchimp',
				},
				{
					className: 'fab fa-mandalorian',
					options: [
						'fab fa-mandalorian',
					],
					defaultOption: 'fab fa-mandalorian',
					keywords: 'mandalorian',
				},
				{
					className: 'fab fa-markdown',
					options: [
						'fab fa-markdown',
					],
					defaultOption: 'fab fa-markdown',
					keywords: 'markdown',
				},
				{
					className: 'fab fa-mastodon',
					options: [
						'fab fa-mastodon',
					],
					defaultOption: 'fab fa-mastodon',
					keywords: 'mastodon',
				},
				{
					className: 'fab fa-maxcdn',
					options: [
						'fab fa-maxcdn',
					],
					defaultOption: 'fab fa-maxcdn',
					keywords: 'maxcdn',
				},
				{
					className: 'fab fa-mdb',
					options: [
						'fab fa-mdb',
					],
					defaultOption: 'fab fa-mdb',
					keywords: 'mdb',
				},
				{
					className: 'fab fa-medapps',
					options: [
						'fab fa-medapps',
					],
					defaultOption: 'fab fa-medapps',
					keywords: 'medapps',
				},
				{
					className: 'fab fa-medium',
					options: [
						'fab fa-medium',
					],
					defaultOption: 'fab fa-medium',
					keywords: 'medium',
				},
				{
					className: 'fab fa-medrt',
					options: [
						'fab fa-medrt',
					],
					defaultOption: 'fab fa-medrt',
					keywords: 'medrt',
				},
				{
					className: 'fab fa-meetup',
					options: [
						'fab fa-meetup',
					],
					defaultOption: 'fab fa-meetup',
					keywords: 'meetup',
				},
				{
					className: 'fab fa-megaport',
					options: [
						'fab fa-megaport',
					],
					defaultOption: 'fab fa-megaport',
					keywords: 'megaport',
				},
				{
					className: 'fab fa-mendeley',
					options: [
						'fab fa-mendeley',
					],
					defaultOption: 'fab fa-mendeley',
					keywords: 'mendeley',
				},
				{
					className: 'fab fa-microblog',
					options: [
						'fab fa-microblog',
					],
					defaultOption: 'fab fa-microblog',
					keywords: 'microblog',
				},
				{
					className: 'fab fa-microsoft',
					options: [
						'fab fa-microsoft',
					],
					defaultOption: 'fab fa-microsoft',
					keywords: 'microsoft',
				},
				{
					className: 'fab fa-mix',
					options: [
						'fab fa-mix',
					],
					defaultOption: 'fab fa-mix',
					keywords: 'mix',
				},
				{
					className: 'fab fa-mixcloud',
					options: [
						'fab fa-mixcloud',
					],
					defaultOption: 'fab fa-mixcloud',
					keywords: 'mixcloud',
				},
				{
					className: 'fab fa-mixer',
					options: [
						'fab fa-mixer',
					],
					defaultOption: 'fab fa-mixer',
					keywords: 'mixer',
				},
				{
					className: 'fab fa-mizuni',
					options: [
						'fab fa-mizuni',
					],
					defaultOption: 'fab fa-mizuni',
					keywords: 'mizuni',
				},
				{
					className: 'fab fa-modx',
					options: [
						'fab fa-modx',
					],
					defaultOption: 'fab fa-modx',
					keywords: 'modx',
				},
				{
					className: 'fab fa-monero',
					options: [
						'fab fa-monero',
					],
					defaultOption: 'fab fa-monero',
					keywords: 'monero',
				},
				{
					className: 'fab fa-napster',
					options: [
						'fab fa-napster',
					],
					defaultOption: 'fab fa-napster',
					keywords: 'napster',
				},
				{
					className: 'fab fa-neos',
					options: [
						'fab fa-neos',
					],
					defaultOption: 'fab fa-neos',
					keywords: 'neos',
				},
				{
					className: 'fab fa-nimblr',
					options: [
						'fab fa-nimblr',
					],
					defaultOption: 'fab fa-nimblr',
					keywords: 'nimblr',
				},
				{
					className: 'fab fa-node',
					options: [
						'fab fa-node',
					],
					defaultOption: 'fab fa-node',
					keywords: 'node',
				},
				{
					className: 'fab fa-node-js',
					options: [
						'fab fa-node-js',
					],
					defaultOption: 'fab fa-node-js',
					keywords: 'node js',
				},
				{
					className: 'fab fa-npm',
					options: [
						'fab fa-npm',
					],
					defaultOption: 'fab fa-npm',
					keywords: 'npm',
				},
				{
					className: 'fab fa-ns8',
					options: [
						'fab fa-ns8',
					],
					defaultOption: 'fab fa-ns8',
					keywords: 'ns8',
				},
				{
					className: 'fab fa-nutritionix',
					options: [
						'fab fa-nutritionix',
					],
					defaultOption: 'fab fa-nutritionix',
					keywords: 'nutritionix',
				},
				{
					className: 'fab fa-octopus-deploy',
					options: [
						'fab fa-octopus-deploy',
					],
					defaultOption: 'fab fa-octopus-deploy',
					keywords: 'octopus deploy',
				},
				{
					className: 'fab fa-odnoklassniki',
					options: [
						'fab fa-odnoklassniki',
					],
					defaultOption: 'fab fa-odnoklassniki',
					keywords: 'odnoklassniki',
				},
				{
					className: 'fab fa-odnoklassniki-square',
					options: [
						'fab fa-odnoklassniki-square',
					],
					defaultOption: 'fab fa-odnoklassniki-square',
					keywords: 'odnoklassniki square',
				},
				{
					className: 'fab fa-old-republic',
					options: [
						'fab fa-old-republic',
					],
					defaultOption: 'fab fa-old-republic',
					keywords: 'politics star wars old republic',
				},
				{
					className: 'fab fa-opencart',
					options: [
						'fab fa-opencart',
					],
					defaultOption: 'fab fa-opencart',
					keywords: 'opencart',
				},
				{
					className: 'fab fa-openid',
					options: [
						'fab fa-openid',
					],
					defaultOption: 'fab fa-openid',
					keywords: 'openid',
				},
				{
					className: 'fab fa-opera',
					options: [
						'fab fa-opera',
					],
					defaultOption: 'fab fa-opera',
					keywords: 'opera',
				},
				{
					className: 'fab fa-optin-monster',
					options: [
						'fab fa-optin-monster',
					],
					defaultOption: 'fab fa-optin-monster',
					keywords: 'optin monster',
				},
				{
					className: 'fab fa-orcid',
					options: [
						'fab fa-orcid',
					],
					defaultOption: 'fab fa-orcid',
					keywords: 'orcid',
				},
				{
					className: 'fab fa-osi',
					options: [
						'fab fa-osi',
					],
					defaultOption: 'fab fa-osi',
					keywords: 'osi',
				},
				{
					className: 'fab fa-page4',
					options: [
						'fab fa-page4',
					],
					defaultOption: 'fab fa-page4',
					keywords: 'page4',
				},
				{
					className: 'fab fa-pagelines',
					options: [
						'fab fa-pagelines',
					],
					defaultOption: 'fab fa-pagelines',
					keywords: 'eco flora leaf leaves nature plant tree pagelines',
				},
				{
					className: 'fab fa-palfed',
					options: [
						'fab fa-palfed',
					],
					defaultOption: 'fab fa-palfed',
					keywords: 'palfed',
				},
				{
					className: 'fab fa-patreon',
					options: [
						'fab fa-patreon',
					],
					defaultOption: 'fab fa-patreon',
					keywords: 'patreon',
				},
				{
					className: 'fab fa-paypal',
					options: [
						'fab fa-paypal',
					],
					defaultOption: 'fab fa-paypal',
					keywords: 'paypal',
				},
				{
					className: 'fab fa-penny-arcade',
					options: [
						'fab fa-penny-arcade',
					],
					defaultOption: 'fab fa-penny-arcade',
					keywords: 'dungeons & dragons d&d dnd fantasy game gaming pax tabletop penny arcade',
				},
				{
					className: 'fab fa-perbyte',
					options: [
						'fab fa-perbyte',
					],
					defaultOption: 'fab fa-perbyte',
					keywords: 'perbyte',
				},
				{
					className: 'fab fa-periscope',
					options: [
						'fab fa-periscope',
					],
					defaultOption: 'fab fa-periscope',
					keywords: 'periscope',
				},
				{
					className: 'fab fa-phabricator',
					options: [
						'fab fa-phabricator',
					],
					defaultOption: 'fab fa-phabricator',
					keywords: 'phabricator',
				},
				{
					className: 'fab fa-phoenix-framework',
					options: [
						'fab fa-phoenix-framework',
					],
					defaultOption: 'fab fa-phoenix-framework',
					keywords: 'phoenix framework',
				},
				{
					className: 'fab fa-phoenix-squadron',
					options: [
						'fab fa-phoenix-squadron',
					],
					defaultOption: 'fab fa-phoenix-squadron',
					keywords: 'phoenix squadron',
				},
				{
					className: 'fab fa-php',
					options: [
						'fab fa-php',
					],
					defaultOption: 'fab fa-php',
					keywords: 'php',
				},
				{
					className: 'fab fa-pied-piper',
					options: [
						'fab fa-pied-piper',
					],
					defaultOption: 'fab fa-pied-piper',
					keywords: 'pied piper',
				},
				{
					className: 'fab fa-pied-piper-alt',
					options: [
						'fab fa-pied-piper-alt',
					],
					defaultOption: 'fab fa-pied-piper-alt',
					keywords: 'pied piper alt',
				},
				{
					className: 'fab fa-pied-piper-hat',
					options: [
						'fab fa-pied-piper-hat',
					],
					defaultOption: 'fab fa-pied-piper-hat',
					keywords: 'clothing pied piper hat',
				},
				{
					className: 'fab fa-pied-piper-pp',
					options: [
						'fab fa-pied-piper-pp',
					],
					defaultOption: 'fab fa-pied-piper-pp',
					keywords: 'pied piper pp',
				},
				{
					className: 'fab fa-pied-piper-square',
					options: [
						'fab fa-pied-piper-square',
					],
					defaultOption: 'fab fa-pied-piper-square',
					keywords: 'pied piper square',
				},
				{
					className: 'fab fa-pinterest',
					options: [
						'fab fa-pinterest',
					],
					defaultOption: 'fab fa-pinterest',
					keywords: 'pinterest',
				},
				{
					className: 'fab fa-pinterest-p',
					options: [
						'fab fa-pinterest-p',
					],
					defaultOption: 'fab fa-pinterest-p',
					keywords: 'pinterest p',
				},
				{
					className: 'fab fa-pinterest-square',
					options: [
						'fab fa-pinterest-square',
					],
					defaultOption: 'fab fa-pinterest-square',
					keywords: 'pinterest square',
				},
				{
					className: 'fab fa-pix',
					options: [
						'fab fa-pix',
					],
					defaultOption: 'fab fa-pix',
					keywords: 'pix',
				},
				{
					className: 'fab fa-playstation',
					options: [
						'fab fa-playstation',
					],
					defaultOption: 'fab fa-playstation',
					keywords: 'playstation',
				},
				{
					className: 'fab fa-product-hunt',
					options: [
						'fab fa-product-hunt',
					],
					defaultOption: 'fab fa-product-hunt',
					keywords: 'product hunt',
				},
				{
					className: 'fab fa-pushed',
					options: [
						'fab fa-pushed',
					],
					defaultOption: 'fab fa-pushed',
					keywords: 'pushed',
				},
				{
					className: 'fab fa-python',
					options: [
						'fab fa-python',
					],
					defaultOption: 'fab fa-python',
					keywords: 'python',
				},
				{
					className: 'fab fa-qq',
					options: [
						'fab fa-qq',
					],
					defaultOption: 'fab fa-qq',
					keywords: 'qq',
				},
				{
					className: 'fab fa-quinscape',
					options: [
						'fab fa-quinscape',
					],
					defaultOption: 'fab fa-quinscape',
					keywords: 'quinscape',
				},
				{
					className: 'fab fa-quora',
					options: [
						'fab fa-quora',
					],
					defaultOption: 'fab fa-quora',
					keywords: 'quora',
				},
				{
					className: 'fab fa-r-project',
					options: [
						'fab fa-r-project',
					],
					defaultOption: 'fab fa-r-project',
					keywords: 'r project',
				},
				{
					className: 'fab fa-raspberry-pi',
					options: [
						'fab fa-raspberry-pi',
					],
					defaultOption: 'fab fa-raspberry-pi',
					keywords: 'raspberry pi',
				},
				{
					className: 'fab fa-ravelry',
					options: [
						'fab fa-ravelry',
					],
					defaultOption: 'fab fa-ravelry',
					keywords: 'ravelry',
				},
				{
					className: 'fab fa-react',
					options: [
						'fab fa-react',
					],
					defaultOption: 'fab fa-react',
					keywords: 'react',
				},
				{
					className: 'fab fa-reacteurope',
					options: [
						'fab fa-reacteurope',
					],
					defaultOption: 'fab fa-reacteurope',
					keywords: 'reacteurope',
				},
				{
					className: 'fab fa-readme',
					options: [
						'fab fa-readme',
					],
					defaultOption: 'fab fa-readme',
					keywords: 'readme',
				},
				{
					className: 'fab fa-rebel',
					options: [
						'fab fa-rebel',
					],
					defaultOption: 'fab fa-rebel',
					keywords: 'rebel',
				},
				{
					className: 'fab fa-red-river',
					options: [
						'fab fa-red-river',
					],
					defaultOption: 'fab fa-red-river',
					keywords: 'red river',
				},
				{
					className: 'fab fa-reddit',
					options: [
						'fab fa-reddit',
					],
					defaultOption: 'fab fa-reddit',
					keywords: 'reddit',
				},
				{
					className: 'fab fa-reddit-alien',
					options: [
						'fab fa-reddit-alien',
					],
					defaultOption: 'fab fa-reddit-alien',
					keywords: 'reddit alien',
				},
				{
					className: 'fab fa-reddit-square',
					options: [
						'fab fa-reddit-square',
					],
					defaultOption: 'fab fa-reddit-square',
					keywords: 'reddit square',
				},
				{
					className: 'fab fa-redhat',
					options: [
						'fab fa-redhat',
					],
					defaultOption: 'fab fa-redhat',
					keywords: 'linux operating system os redhat',
				},
				{
					className: 'fab fa-renren',
					options: [
						'fab fa-renren',
					],
					defaultOption: 'fab fa-renren',
					keywords: 'renren',
				},
				{
					className: 'fab fa-replyd',
					options: [
						'fab fa-replyd',
					],
					defaultOption: 'fab fa-replyd',
					keywords: 'replyd',
				},
				{
					className: 'fab fa-researchgate',
					options: [
						'fab fa-researchgate',
					],
					defaultOption: 'fab fa-researchgate',
					keywords: 'researchgate',
				},
				{
					className: 'fab fa-resolving',
					options: [
						'fab fa-resolving',
					],
					defaultOption: 'fab fa-resolving',
					keywords: 'resolving',
				},
				{
					className: 'fab fa-rev',
					options: [
						'fab fa-rev',
					],
					defaultOption: 'fab fa-rev',
					keywords: 'rev',
				},
				{
					className: 'fab fa-rocketchat',
					options: [
						'fab fa-rocketchat',
					],
					defaultOption: 'fab fa-rocketchat',
					keywords: 'rocketchat',
				},
				{
					className: 'fab fa-rockrms',
					options: [
						'fab fa-rockrms',
					],
					defaultOption: 'fab fa-rockrms',
					keywords: 'rockrms',
				},
				{
					className: 'fab fa-rust',
					options: [
						'fab fa-rust',
					],
					defaultOption: 'fab fa-rust',
					keywords: 'rust',
				},
				{
					className: 'fab fa-safari',
					options: [
						'fab fa-safari',
					],
					defaultOption: 'fab fa-safari',
					keywords: 'browser safari',
				},
				{
					className: 'fab fa-salesforce',
					options: [
						'fab fa-salesforce',
					],
					defaultOption: 'fab fa-salesforce',
					keywords: 'salesforce',
				},
				{
					className: 'fab fa-sass',
					options: [
						'fab fa-sass',
					],
					defaultOption: 'fab fa-sass',
					keywords: 'sass',
				},
				{
					className: 'fab fa-schlix',
					options: [
						'fab fa-schlix',
					],
					defaultOption: 'fab fa-schlix',
					keywords: 'schlix',
				},
				{
					className: 'fab fa-scribd',
					options: [
						'fab fa-scribd',
					],
					defaultOption: 'fab fa-scribd',
					keywords: 'scribd',
				},
				{
					className: 'fab fa-searchengin',
					options: [
						'fab fa-searchengin',
					],
					defaultOption: 'fab fa-searchengin',
					keywords: 'searchengin',
				},
				{
					className: 'fab fa-sellcast',
					options: [
						'fab fa-sellcast',
					],
					defaultOption: 'fab fa-sellcast',
					keywords: 'eercast sellcast',
				},
				{
					className: 'fab fa-sellsy',
					options: [
						'fab fa-sellsy',
					],
					defaultOption: 'fab fa-sellsy',
					keywords: 'sellsy',
				},
				{
					className: 'fab fa-servicestack',
					options: [
						'fab fa-servicestack',
					],
					defaultOption: 'fab fa-servicestack',
					keywords: 'servicestack',
				},
				{
					className: 'fab fa-shirtsinbulk',
					options: [
						'fab fa-shirtsinbulk',
					],
					defaultOption: 'fab fa-shirtsinbulk',
					keywords: 'shirtsinbulk',
				},
				{
					className: 'fab fa-shopify',
					options: [
						'fab fa-shopify',
					],
					defaultOption: 'fab fa-shopify',
					keywords: 'shopify',
				},
				{
					className: 'fab fa-shopware',
					options: [
						'fab fa-shopware',
					],
					defaultOption: 'fab fa-shopware',
					keywords: 'shopware',
				},
				{
					className: 'fab fa-simplybuilt',
					options: [
						'fab fa-simplybuilt',
					],
					defaultOption: 'fab fa-simplybuilt',
					keywords: 'simplybuilt',
				},
				{
					className: 'fab fa-sistrix',
					options: [
						'fab fa-sistrix',
					],
					defaultOption: 'fab fa-sistrix',
					keywords: 'sistrix',
				},
				{
					className: 'fab fa-sith',
					options: [
						'fab fa-sith',
					],
					defaultOption: 'fab fa-sith',
					keywords: 'sith',
				},
				{
					className: 'fab fa-sitrox',
					options: [
						'fab fa-sitrox',
					],
					defaultOption: 'fab fa-sitrox',
					keywords: 'sitrox',
				},
				{
					className: 'fab fa-sketch',
					options: [
						'fab fa-sketch',
					],
					defaultOption: 'fab fa-sketch',
					keywords: 'app design interface sketch',
				},
				{
					className: 'fab fa-skyatlas',
					options: [
						'fab fa-skyatlas',
					],
					defaultOption: 'fab fa-skyatlas',
					keywords: 'skyatlas',
				},
				{
					className: 'fab fa-skype',
					options: [
						'fab fa-skype',
					],
					defaultOption: 'fab fa-skype',
					keywords: 'skype',
				},
				{
					className: 'fab fa-slack',
					options: [
						'fab fa-slack',
					],
					defaultOption: 'fab fa-slack',
					keywords: 'anchor hash hashtag slack',
				},
				{
					className: 'fab fa-slideshare',
					options: [
						'fab fa-slideshare',
					],
					defaultOption: 'fab fa-slideshare',
					keywords: 'slideshare',
				},
				{
					className: 'fab fa-snapchat',
					options: [
						'fab fa-snapchat',
					],
					defaultOption: 'fab fa-snapchat',
					keywords: 'snapchat',
				},
				{
					className: 'fab fa-snapchat-square',
					options: [
						'fab fa-snapchat-square',
					],
					defaultOption: 'fab fa-snapchat-square',
					keywords: 'snapchat square',
				},
				{
					className: 'fab fa-soundcloud',
					options: [
						'fab fa-soundcloud',
					],
					defaultOption: 'fab fa-soundcloud',
					keywords: 'soundcloud',
				},
				{
					className: 'fab fa-sourcetree',
					options: [
						'fab fa-sourcetree',
					],
					defaultOption: 'fab fa-sourcetree',
					keywords: 'sourcetree',
				},
				{
					className: 'fab fa-speakap',
					options: [
						'fab fa-speakap',
					],
					defaultOption: 'fab fa-speakap',
					keywords: 'speakap',
				},
				{
					className: 'fab fa-speaker-deck',
					options: [
						'fab fa-speaker-deck',
					],
					defaultOption: 'fab fa-speaker-deck',
					keywords: 'speaker deck',
				},
				{
					className: 'fab fa-spotify',
					options: [
						'fab fa-spotify',
					],
					defaultOption: 'fab fa-spotify',
					keywords: 'spotify',
				},
				{
					className: 'fab fa-square-font-awesome',
					options: [
						'fab fa-square-font-awesome',
					],
					defaultOption: 'fab fa-square-font-awesome',
					keywords: 'square font awesome',
				},
				{
					className: 'fab fa-square-font-awesome-stroke',
					options: [
						'fab fa-square-font-awesome-stroke',
					],
					defaultOption: 'fab fa-square-font-awesome-stroke',
					keywords: 'square font awesome stroke',
				},
				{
					className: 'fab fa-squarespace',
					options: [
						'fab fa-squarespace',
					],
					defaultOption: 'fab fa-squarespace',
					keywords: 'squarespace',
				},
				{
					className: 'fab fa-stack-exchange',
					options: [
						'fab fa-stack-exchange',
					],
					defaultOption: 'fab fa-stack-exchange',
					keywords: 'stack exchange',
				},
				{
					className: 'fab fa-stack-overflow',
					options: [
						'fab fa-stack-overflow',
					],
					defaultOption: 'fab fa-stack-overflow',
					keywords: 'stack overflow',
				},
				{
					className: 'fab fa-stackpath',
					options: [
						'fab fa-stackpath',
					],
					defaultOption: 'fab fa-stackpath',
					keywords: 'stackpath',
				},
				{
					className: 'fab fa-staylinked',
					options: [
						'fab fa-staylinked',
					],
					defaultOption: 'fab fa-staylinked',
					keywords: 'staylinked',
				},
				{
					className: 'fab fa-steam',
					options: [
						'fab fa-steam',
					],
					defaultOption: 'fab fa-steam',
					keywords: 'steam',
				},
				{
					className: 'fab fa-steam-square',
					options: [
						'fab fa-steam-square',
					],
					defaultOption: 'fab fa-steam-square',
					keywords: 'steam square',
				},
				{
					className: 'fab fa-steam-symbol',
					options: [
						'fab fa-steam-symbol',
					],
					defaultOption: 'fab fa-steam-symbol',
					keywords: 'steam symbol',
				},
				{
					className: 'fab fa-sticker-mule',
					options: [
						'fab fa-sticker-mule',
					],
					defaultOption: 'fab fa-sticker-mule',
					keywords: 'sticker mule',
				},
				{
					className: 'fab fa-strava',
					options: [
						'fab fa-strava',
					],
					defaultOption: 'fab fa-strava',
					keywords: 'strava',
				},
				{
					className: 'fab fa-stripe',
					options: [
						'fab fa-stripe',
					],
					defaultOption: 'fab fa-stripe',
					keywords: 'stripe',
				},
				{
					className: 'fab fa-stripe-s',
					options: [
						'fab fa-stripe-s',
					],
					defaultOption: 'fab fa-stripe-s',
					keywords: 'stripe s',
				},
				{
					className: 'fab fa-studiovinari',
					options: [
						'fab fa-studiovinari',
					],
					defaultOption: 'fab fa-studiovinari',
					keywords: 'studiovinari',
				},
				{
					className: 'fab fa-stumbleupon',
					options: [
						'fab fa-stumbleupon',
					],
					defaultOption: 'fab fa-stumbleupon',
					keywords: 'stumbleupon',
				},
				{
					className: 'fab fa-stumbleupon-circle',
					options: [
						'fab fa-stumbleupon-circle',
					],
					defaultOption: 'fab fa-stumbleupon-circle',
					keywords: 'stumbleupon circle',
				},
				{
					className: 'fab fa-superpowers',
					options: [
						'fab fa-superpowers',
					],
					defaultOption: 'fab fa-superpowers',
					keywords: 'superpowers',
				},
				{
					className: 'fab fa-supple',
					options: [
						'fab fa-supple',
					],
					defaultOption: 'fab fa-supple',
					keywords: 'supple',
				},
				{
					className: 'fab fa-suse',
					options: [
						'fab fa-suse',
					],
					defaultOption: 'fab fa-suse',
					keywords: 'linux operating system os suse',
				},
				{
					className: 'fab fa-swift',
					options: [
						'fab fa-swift',
					],
					defaultOption: 'fab fa-swift',
					keywords: 'swift',
				},
				{
					className: 'fab fa-symfony',
					options: [
						'fab fa-symfony',
					],
					defaultOption: 'fab fa-symfony',
					keywords: 'symfony',
				},
				{
					className: 'fab fa-teamspeak',
					options: [
						'fab fa-teamspeak',
					],
					defaultOption: 'fab fa-teamspeak',
					keywords: 'teamspeak',
				},
				{
					className: 'fab fa-telegram',
					options: [
						'fab fa-telegram',
					],
					defaultOption: 'fab fa-telegram',
					keywords: 'telegram',
				},
				{
					className: 'fab fa-tencent-weibo',
					options: [
						'fab fa-tencent-weibo',
					],
					defaultOption: 'fab fa-tencent-weibo',
					keywords: 'tencent weibo',
				},
				{
					className: 'fab fa-the-red-yeti',
					options: [
						'fab fa-the-red-yeti',
					],
					defaultOption: 'fab fa-the-red-yeti',
					keywords: 'the red yeti',
				},
				{
					className: 'fab fa-themeco',
					options: [
						'fab fa-themeco',
					],
					defaultOption: 'fab fa-themeco',
					keywords: 'themeco',
				},
				{
					className: 'fab fa-themeisle',
					options: [
						'fab fa-themeisle',
					],
					defaultOption: 'fab fa-themeisle',
					keywords: 'themeisle',
				},
				{
					className: 'fab fa-think-peaks',
					options: [
						'fab fa-think-peaks',
					],
					defaultOption: 'fab fa-think-peaks',
					keywords: 'think peaks',
				},
				{
					className: 'fab fa-tiktok',
					options: [
						'fab fa-tiktok',
					],
					defaultOption: 'fab fa-tiktok',
					keywords: 'tiktok',
				},
				{
					className: 'fab fa-trade-federation',
					options: [
						'fab fa-trade-federation',
					],
					defaultOption: 'fab fa-trade-federation',
					keywords: 'trade federation',
				},
				{
					className: 'fab fa-trello',
					options: [
						'fab fa-trello',
					],
					defaultOption: 'fab fa-trello',
					keywords: 'atlassian trello',
				},
				{
					className: 'fab fa-tumblr',
					options: [
						'fab fa-tumblr',
					],
					defaultOption: 'fab fa-tumblr',
					keywords: 'tumblr',
				},
				{
					className: 'fab fa-tumblr-square',
					options: [
						'fab fa-tumblr-square',
					],
					defaultOption: 'fab fa-tumblr-square',
					keywords: 'tumblr square',
				},
				{
					className: 'fab fa-twitch',
					options: [
						'fab fa-twitch',
					],
					defaultOption: 'fab fa-twitch',
					keywords: 'twitch',
				},
				{
					className: 'fab fa-twitter',
					options: [
						'fab fa-twitter',
					],
					defaultOption: 'fab fa-twitter',
					keywords: 'social network tweet twitter',
				},
				{
					className: 'fab fa-twitter-square',
					options: [
						'fab fa-twitter-square',
					],
					defaultOption: 'fab fa-twitter-square',
					keywords: 'social network tweet twitter square',
				},
				{
					className: 'fab fa-typo3',
					options: [
						'fab fa-typo3',
					],
					defaultOption: 'fab fa-typo3',
					keywords: 'typo3',
				},
				{
					className: 'fab fa-uber',
					options: [
						'fab fa-uber',
					],
					defaultOption: 'fab fa-uber',
					keywords: 'uber',
				},
				{
					className: 'fab fa-ubuntu',
					options: [
						'fab fa-ubuntu',
					],
					defaultOption: 'fab fa-ubuntu',
					keywords: 'linux operating system os ubuntu',
				},
				{
					className: 'fab fa-uikit',
					options: [
						'fab fa-uikit',
					],
					defaultOption: 'fab fa-uikit',
					keywords: 'uikit',
				},
				{
					className: 'fab fa-umbraco',
					options: [
						'fab fa-umbraco',
					],
					defaultOption: 'fab fa-umbraco',
					keywords: 'umbraco',
				},
				{
					className: 'fab fa-uncharted',
					options: [
						'fab fa-uncharted',
					],
					defaultOption: 'fab fa-uncharted',
					keywords: 'uncharted',
				},
				{
					className: 'fab fa-uniregistry',
					options: [
						'fab fa-uniregistry',
					],
					defaultOption: 'fab fa-uniregistry',
					keywords: 'uniregistry',
				},
				{
					className: 'fab fa-unity',
					options: [
						'fab fa-unity',
					],
					defaultOption: 'fab fa-unity',
					keywords: 'unity',
				},
				{
					className: 'fab fa-unsplash',
					options: [
						'fab fa-unsplash',
					],
					defaultOption: 'fab fa-unsplash',
					keywords: 'unsplash',
				},
				{
					className: 'fab fa-untappd',
					options: [
						'fab fa-untappd',
					],
					defaultOption: 'fab fa-untappd',
					keywords: 'untappd',
				},
				{
					className: 'fab fa-ups',
					options: [
						'fab fa-ups',
					],
					defaultOption: 'fab fa-ups',
					keywords: 'united parcel service package shipping ups',
				},
				{
					className: 'fab fa-usb',
					options: [
						'fab fa-usb',
					],
					defaultOption: 'fab fa-usb',
					keywords: 'usb',
				},
				{
					className: 'fab fa-usps',
					options: [
						'fab fa-usps',
					],
					defaultOption: 'fab fa-usps',
					keywords: 'american package shipping usa usps',
				},
				{
					className: 'fab fa-ussunnah',
					options: [
						'fab fa-ussunnah',
					],
					defaultOption: 'fab fa-ussunnah',
					keywords: 'ussunnah',
				},
				{
					className: 'fab fa-vaadin',
					options: [
						'fab fa-vaadin',
					],
					defaultOption: 'fab fa-vaadin',
					keywords: 'vaadin',
				},
				{
					className: 'fab fa-viacoin',
					options: [
						'fab fa-viacoin',
					],
					defaultOption: 'fab fa-viacoin',
					keywords: 'viacoin',
				},
				{
					className: 'fab fa-viadeo',
					options: [
						'fab fa-viadeo',
					],
					defaultOption: 'fab fa-viadeo',
					keywords: 'viadeo',
				},
				{
					className: 'fab fa-viadeo-square',
					options: [
						'fab fa-viadeo-square',
					],
					defaultOption: 'fab fa-viadeo-square',
					keywords: 'viadeo square',
				},
				{
					className: 'fab fa-viber',
					options: [
						'fab fa-viber',
					],
					defaultOption: 'fab fa-viber',
					keywords: 'viber',
				},
				{
					className: 'fab fa-vimeo',
					options: [
						'fab fa-vimeo',
					],
					defaultOption: 'fab fa-vimeo',
					keywords: 'vimeo',
				},
				{
					className: 'fab fa-vimeo-square',
					options: [
						'fab fa-vimeo-square',
					],
					defaultOption: 'fab fa-vimeo-square',
					keywords: 'vimeo square',
				},
				{
					className: 'fab fa-vimeo-v',
					options: [
						'fab fa-vimeo-v',
					],
					defaultOption: 'fab fa-vimeo-v',
					keywords: 'vimeo vimeo v',
				},
				{
					className: 'fab fa-vine',
					options: [
						'fab fa-vine',
					],
					defaultOption: 'fab fa-vine',
					keywords: 'vine',
				},
				{
					className: 'fab fa-vk',
					options: [
						'fab fa-vk',
					],
					defaultOption: 'fab fa-vk',
					keywords: 'vk',
				},
				{
					className: 'fab fa-vnv',
					options: [
						'fab fa-vnv',
					],
					defaultOption: 'fab fa-vnv',
					keywords: 'vnv',
				},
				{
					className: 'fab fa-vuejs',
					options: [
						'fab fa-vuejs',
					],
					defaultOption: 'fab fa-vuejs',
					keywords: 'vuejs',
				},
				{
					className: 'fab fa-watchman-monitoring',
					options: [
						'fab fa-watchman-monitoring',
					],
					defaultOption: 'fab fa-watchman-monitoring',
					keywords: 'watchman monitoring',
				},
				{
					className: 'fab fa-waze',
					options: [
						'fab fa-waze',
					],
					defaultOption: 'fab fa-waze',
					keywords: 'waze',
				},
				{
					className: 'fab fa-weebly',
					options: [
						'fab fa-weebly',
					],
					defaultOption: 'fab fa-weebly',
					keywords: 'weebly',
				},
				{
					className: 'fab fa-weibo',
					options: [
						'fab fa-weibo',
					],
					defaultOption: 'fab fa-weibo',
					keywords: 'weibo',
				},
				{
					className: 'fab fa-weixin',
					options: [
						'fab fa-weixin',
					],
					defaultOption: 'fab fa-weixin',
					keywords: 'weixin',
				},
				{
					className: 'fab fa-whatsapp',
					options: [
						'fab fa-whatsapp',
					],
					defaultOption: 'fab fa-whatsapp',
					keywords: 'whatsapp',
				},
				{
					className: 'fab fa-whatsapp-square',
					options: [
						'fab fa-whatsapp-square',
					],
					defaultOption: 'fab fa-whatsapp-square',
					keywords: 'whatsapp square',
				},
				{
					className: 'fab fa-whmcs',
					options: [
						'fab fa-whmcs',
					],
					defaultOption: 'fab fa-whmcs',
					keywords: 'whmcs',
				},
				{
					className: 'fab fa-wikipedia-w',
					options: [
						'fab fa-wikipedia-w',
					],
					defaultOption: 'fab fa-wikipedia-w',
					keywords: 'wikipedia w',
				},
				{
					className: 'fab fa-windows',
					options: [
						'fab fa-windows',
					],
					defaultOption: 'fab fa-windows',
					keywords: 'microsoft operating system os windows',
				},
				{
					className: 'fab fa-wirsindhandwerk',
					options: [
						'fab fa-wirsindhandwerk',
					],
					defaultOption: 'fab fa-wirsindhandwerk',
					keywords: 'wirsindhandwerk',
				},
				{
					className: 'fab fa-wix',
					options: [
						'fab fa-wix',
					],
					defaultOption: 'fab fa-wix',
					keywords: 'wix',
				},
				{
					className: 'fab fa-wizards-of-the-coast',
					options: [
						'fab fa-wizards-of-the-coast',
					],
					defaultOption: 'fab fa-wizards-of-the-coast',
					keywords: 'dungeons & dragons d&d dnd fantasy game gaming tabletop wizards of the coast',
				},
				{
					className: 'fab fa-wodu',
					options: [
						'fab fa-wodu',
					],
					defaultOption: 'fab fa-wodu',
					keywords: 'wodu',
				},
				{
					className: 'fab fa-wolf-pack-battalion',
					options: [
						'fab fa-wolf-pack-battalion',
					],
					defaultOption: 'fab fa-wolf-pack-battalion',
					keywords: 'wolf pack battalion',
				},
				{
					className: 'fab fa-wordpress',
					options: [
						'fab fa-wordpress',
					],
					defaultOption: 'fab fa-wordpress',
					keywords: 'wordpress',
				},
				{
					className: 'fab fa-wordpress-simple',
					options: [
						'fab fa-wordpress-simple',
					],
					defaultOption: 'fab fa-wordpress-simple',
					keywords: 'wordpress simple',
				},
				{
					className: 'fab fa-wpbeginner',
					options: [
						'fab fa-wpbeginner',
					],
					defaultOption: 'fab fa-wpbeginner',
					keywords: 'wpbeginner',
				},
				{
					className: 'fab fa-wpexplorer',
					options: [
						'fab fa-wpexplorer',
					],
					defaultOption: 'fab fa-wpexplorer',
					keywords: 'wpexplorer',
				},
				{
					className: 'fab fa-wpforms',
					options: [
						'fab fa-wpforms',
					],
					defaultOption: 'fab fa-wpforms',
					keywords: 'wpforms',
				},
				{
					className: 'fab fa-wpressr',
					options: [
						'fab fa-wpressr',
					],
					defaultOption: 'fab fa-wpressr',
					keywords: 'rendact wpressr',
				},
				{
					className: 'fab fa-xbox',
					options: [
						'fab fa-xbox',
					],
					defaultOption: 'fab fa-xbox',
					keywords: 'xbox',
				},
				{
					className: 'fab fa-xing',
					options: [
						'fab fa-xing',
					],
					defaultOption: 'fab fa-xing',
					keywords: 'xing',
				},
				{
					className: 'fab fa-xing-square',
					options: [
						'fab fa-xing-square',
					],
					defaultOption: 'fab fa-xing-square',
					keywords: 'xing square',
				},
				{
					className: 'fab fa-y-combinator',
					options: [
						'fab fa-y-combinator',
					],
					defaultOption: 'fab fa-y-combinator',
					keywords: 'y combinator',
				},
				{
					className: 'fab fa-yahoo',
					options: [
						'fab fa-yahoo',
					],
					defaultOption: 'fab fa-yahoo',
					keywords: 'yahoo',
				},
				{
					className: 'fab fa-yammer',
					options: [
						'fab fa-yammer',
					],
					defaultOption: 'fab fa-yammer',
					keywords: 'yammer',
				},
				{
					className: 'fab fa-yandex',
					options: [
						'fab fa-yandex',
					],
					defaultOption: 'fab fa-yandex',
					keywords: 'yandex',
				},
				{
					className: 'fab fa-yandex-international',
					options: [
						'fab fa-yandex-international',
					],
					defaultOption: 'fab fa-yandex-international',
					keywords: 'yandex international',
				},
				{
					className: 'fab fa-yarn',
					options: [
						'fab fa-yarn',
					],
					defaultOption: 'fab fa-yarn',
					keywords: 'yarn',
				},
				{
					className: 'fab fa-yelp',
					options: [
						'fab fa-yelp',
					],
					defaultOption: 'fab fa-yelp',
					keywords: 'yelp',
				},
				{
					className: 'fab fa-yoast',
					options: [
						'fab fa-yoast',
					],
					defaultOption: 'fab fa-yoast',
					keywords: 'yoast',
				},
				{
					className: 'fab fa-youtube',
					options: [
						'fab fa-youtube',
					],
					defaultOption: 'fab fa-youtube',
					keywords: 'film video youtube play youtube square youtube',
				},
				{
					className: 'fab fa-youtube-square',
					options: [
						'fab fa-youtube-square',
					],
					defaultOption: 'fab fa-youtube-square',
					keywords: 'youtube square',
				},
				{
					className: 'fab fa-zhihu',
					options: [
						'fab fa-zhihu',
					],
					defaultOption: 'fab fa-zhihu',
					keywords: 'zhihu',
				},
			],
		},
	],
};
